import {
  PEER_PROFILES_GET,
  PEER_PROFILES_INSTRUMENTS_GET,
  PEER_PROFILES_SELECTED_INSTRUMENTS_GET,
} from '../actions/types';

const initialState = {
  items: [],
  clusteredInstruments: [],
  selectedInstruments: [],
  startDate: null,
  endDate: null,
  numberOfClusters: null,
  peerProfileId: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PEER_PROFILES_GET._SUCCESS: {
      const { peerProfiles } = action.payload;
      state.items = peerProfiles;
      return state;
    }
    case PEER_PROFILES_INSTRUMENTS_GET._SUCCESS: {
      const {
        clusteredInstruments,
        clusteredInstrumentsMap,
        startDate,
        endDate,
        numberOfClusters,
        peerProfileId,
      } = action.payload;

      // store this for refresh
      state.startDate = startDate;
      state.endDate = endDate;
      state.numberOfClusters = numberOfClusters;
      state.peerProfileId = peerProfileId;

      state.clusteredInstruments = clusteredInstruments;
      state.clusteredInstrumentsMap = clusteredInstrumentsMap;
      return state;
    }
    case PEER_PROFILES_SELECTED_INSTRUMENTS_GET._SUCCESS: {
      const { selectedInstruments, selectedInstrumentsMap } = action.payload;
      state.selectedInstruments = selectedInstruments;
      state.selectedInstrumentsMap = selectedInstrumentsMap;
      return state;
    }
    default:
      return state;
  }
};

export { reducer as peerProfiles };
